import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;

export function usePublicData() {
  const [data, setData] = useState(cache);
  useEffect(() => {
    if (cache) { setData(cache); return; }
    api.get("/public/site").then((r) => { cache = r.data; setData(cache); }).catch(() => {});
  }, []);
  return data;
}
